// import React, { useState, useEffect, useRef } from "react";
// import { Typography, Grid, Card, Avatar, Button } from "@mui/material";
// import { useParams } from "react-router-dom";
// import { useNavigate } from "react-router-dom";
// import { useSelector, useDispatch } from "react-redux";
// import { useTranslation } from "react-i18next";
// import { colors } from "../components/Theme/WebTheme";
// import CircularLoading from "../components/CircularLoading";
// import FileUploadIcon from "@mui/icons-material/FileUpload";
// import AlertDialog from "../components/AlertDialog";
// import { api } from "common";
// import { MAIN_COLOR, SECONDORY_COLOR } from "../common/sharedFunctions";
// import { makeStyles } from "@mui/styles";

// const useStyles = makeStyles((theme) => ({
// 	card: {
// 		borderRadius: "10px",
// 		backgroundColor: SECONDORY_COLOR,
// 		minHeight: 60,
// 		minWidth: 300,
// 		display: "flex",
// 		alignItems: "center",
// 		justifyContent: "center",
// 		textAlign: "center",
// 		padding: 2,
// 		marginBottom: 10,
// 		boxShadow: `0px 2px 5px ${MAIN_COLOR}`,
// 	},

// 	txt: {
// 		padding: 10,
// 		fontWeight: "bold",
// 		minHeight: 60,
// 		backgroundColor: SECONDORY_COLOR,
// 		color: colors.LandingPage_Background,
// 		boxShadow: 3,
// 		display: "flex",
// 		justifyContent: "center",
// 		alignItems: "center",
// 	},
// 	buttonStyle: {
// 		borderRadius: "19px",
// 		minHeight: 50,
// 		minWidth: 150,
// 		marginBottom: 20,
// 		marginTop: 20,
// 		textAlign: "center",
// 		cursor: "pointer",
// 		boxShadow: `0px 2px 5px ${SECONDORY_COLOR}`,
// 	},
// 	avatar: {
// 		width: 300,
// 		height: 250,
// 		display: "flex",
// 		flexDirection: "column",
// 		boxShadow: 3,
// 		border: "2px dashed #B5B5B0",
// 		fontSize: 16,
// 		background: "none",
// 		color: "inherit",
// 		fontWeight: "bold",
// 	},
// }));

// function UserDocuments() {
// 	const { id } = useParams();
// 	const { t, i18n } = useTranslation();
// 	const isRTL = i18n.dir();
// 	const navigate = useNavigate();
// 	const { fetchUsersOnce, updateLicenseImage } = api;
// 	const [data, setData] = useState([]);
// 	const staticusers = useSelector((state) => state.usersdata.staticusers);
// 	const dispatch = useDispatch();
// 	const IdInputRef = useRef();
// 	const licenseImageFrontInputRef = useRef();
// 	const licenseImageBackInputRef = useRef();
// 	const loaded = useRef(false);
// 	const [editable, setEditable] = useState(false);
// 	const [idImage, setIdImage] = useState(null);
// 	const [licenseImageFront, setLicenseImageFront] = useState(null);
// 	const [licenseImageBack, setLicenseImageBack] = useState(null);
// 	const [commonAlert, setCommonAlert] = useState({ open: false, msg: "" });
// 	const [loading, setLoading] = useState(false);
// 	const classes = useStyles();

// 	useEffect(() => {
// 		dispatch(fetchUsersOnce());
// 	}, [dispatch, fetchUsersOnce]);

// 	useEffect(() => {
// 		if (staticusers) {
// 			const user = staticusers.filter((user) => user.id === id.toString())[0];
// 			if (!user) {
// 				navigate("/404");
// 			}
// 			setData(user);
// 		} else {
// 			setData([]);
// 		}
// 		loaded.current = true;
// 	}, [staticusers, id, navigate, data]);

// 	const IdImageChange = async (e) => {
// 		setIdImage(e.target.files[0]);
// 	};
// 	const licenseImageBackChange = async (e) => {
// 		setLicenseImageBack(e.target.files[0]);
// 	};
// 	const licenseImageFrontChange = async (e) => {
// 		setLicenseImageFront(e.target.files[0]);
// 	};

// 	const handleCommonAlertClose = (e) => {
// 		e.preventDefault();
// 		setCommonAlert({ open: false, msg: "" });
// 	};
// 	const handleSaveUser = () => {
// 		setLoading(true);

// 		if (idImage) {
// 			dispatch(updateLicenseImage(data.id, idImage, "verifyIdImage")).then(() => {
// 				dispatch(fetchUsersOnce());
// 			});
// 		} else if (data.usertype === "customer" && !idImage) {
// 			setCommonAlert({ open: true, msg: t("upload_verifyIdImage") });
// 		}
// 		if (licenseImageFront) {
// 			dispatch(updateLicenseImage(data.id, licenseImageFront, "licenseImage")).then(() => {
// 				dispatch(fetchUsersOnce());
// 			});
// 		}
// 		if (licenseImageBack) {
// 			dispatch(updateLicenseImage(data.id, licenseImageBack, "licenseImageBack")).then(() => {
// 				dispatch(fetchUsersOnce());
// 			});
// 		}

// 		if (data.usertype === "driver" && !licenseImageBack && !licenseImageFront && !idImage) {
// 			setCommonAlert({ open: true, msg: t("update_profile_title") });
// 		}
// 		setTimeout(() => {
// 			setIdImage(null);
// 			setLicenseImageFront(null);
// 			setLicenseImageBack(null);
// 			setLoading(false);
// 			setEditable(false);
// 		}, 3000);
// 		loaded.current = true;
// 	};

// 	const handleCancel = () => {
// 		setIdImage(null);
// 		setLicenseImageBack(null);
// 		setLicenseImageFront(null);
// 		setEditable(false);
// 	};

// 	return loading ? (
// 		<CircularLoading />
// 	) : (
// 		<>
// 			<div>
// 				<Card
// 					style={{
// 						borderRadius: "19px",
// 						backgroundColor: "#fff",
// 						minHeight: 200,
// 						marginTop: 20,
// 						marginBottom: 20,
// 						padding: 20,
// 					}}>
// 					<div
// 						style={{
// 							display: "flex",
// 							flexDirection: "column",
// 							justifyContent: isRTL === "rtl" ? "flex-end" : "flex-start",
// 						}}>
// 						<Typography
// 							variant="h5"
// 							style={{
// 								margin: "10px 10px 0 5px",
// 							}}>
// 							{t("documents_title")}
// 						</Typography>
// 						<div
// 							style={{
// 								display: "flex",
// 							}}>
// 							<Button
// 								variant="text"
// 								onClick={() => {
// 									navigate("/users");
// 								}}>
// 								<Typography
// 									style={{
// 										margin: "10px 10px 0 5px",
// 										textAlign: isRTL === "rtl" ? "right" : "left",
// 										fontWeight: "bold",
// 										color: MAIN_COLOR,
// 									}}>
// 									{`<<- ${t("go_back")}`}
// 								</Typography>
// 							</Button>
// 						</div>
// 					</div>

// 					<Grid
// 						container
// 						spacing={1}
// 						direction="column"
// 						style={{
// 							display: "flex",
// 							justifyContent: "center",
// 							alignItems: "center",
// 							width: "100%",
// 							height: "100%",
// 						}}>
// 						<Grid item>
// 							<Grid
// 								container
// 								spacing={1}
// 								justifyContent={"center"}
// 								alignItems={"center"}
// 								marginY={10}
// 								gap={2}
// 								sx={{
// 									display: "flex",
// 									flexDirection: "row",
// 									direction: isRTL === "rtl" ? "rtl" : "ltr",
// 								}}>
// 								{editable ? (
// 									<>
// 										<>
// 											{idImage ? (
// 												<div
// 													onClick={() => IdInputRef.current.click()}
// 													style={{
// 														display: "flex",
// 														justifyContent: "center",
// 														marginTop: 10,
// 													}}>
// 													<img
// 														src={URL.createObjectURL(idImage)}
// 														alt="Profile"
// 														style={{
// 															width: 300,
// 															height: 250,
// 															borderRadius: "19px",
// 														}}
// 													/>
// 												</div>
// 											) : (
// 												<div
// 													onClick={() => IdInputRef.current.click()}
// 													style={{
// 														display: "flex",
// 														justifyContent: "center",
// 														marginTop: 30,
// 														cursor: "pointer",
// 													}}>
// 													<Avatar className={classes.avatar} variant="square" sx={{ boxShadow: 3 }}>
// 														<FileUploadIcon
// 															sx={{
// 																fontSize: 100,
// 																marginBottom: 3,
// 																color: "grey",
// 															}}
// 														/>
// 														{t("upload_id_details")}
// 													</Avatar>
// 												</div>
// 											)}
// 											<input onChange={(event) => IdImageChange(event)} multiple={false} ref={IdInputRef} type="file" hidden />
// 										</>
// 										{data?.usertype === "driver" ? (
// 											<>
// 												<>
// 													{licenseImageFront ? (
// 														<div
// 															onClick={() => licenseImageFrontInputRef.current.click()}
// 															style={{
// 																display: "flex",
// 																justifyContent: "center",
// 																marginTop: 10,
// 															}}>
// 															<img
// 																src={URL.createObjectURL(licenseImageFront)}
// 																alt="Profile"
// 																style={{
// 																	width: 300,
// 																	height: 250,
// 																	borderRadius: "19px",
// 																}}
// 															/>
// 														</div>
// 													) : (
// 														<div
// 															onClick={() => licenseImageFrontInputRef.current.click()}
// 															style={{
// 																display: "flex",
// 																justifyContent: "center",
// 																marginTop: 30,
// 																cursor: "pointer",
// 															}}>
// 															<Avatar className={classes.avatar} variant="square" sx={{ boxShadow: 3 }}>
// 																<FileUploadIcon
// 																	sx={{
// 																		fontSize: 100,
// 																		marginBottom: 3,
// 																		color: "grey",
// 																	}}
// 																/>
// 																{t("upload_driving_license_front")}
// 															</Avatar>
// 														</div>
// 													)}
// 													<input
// 														onChange={(event) => licenseImageFrontChange(event)}
// 														multiple={false}
// 														ref={licenseImageFrontInputRef}
// 														type="file"
// 														hidden
// 													/>
// 												</>
// 												<>
// 													{licenseImageBack ? (
// 														<div
// 															onClick={() => licenseImageBackInputRef.current.click()}
// 															style={{
// 																display: "flex",
// 																justifyContent: "center",
// 																marginTop: 10,
// 															}}>
// 															<img
// 																src={URL.createObjectURL(licenseImageBack)}
// 																alt="Profile"
// 																style={{
// 																	width: 300,
// 																	height: 250,
// 																	borderRadius: "19px",
// 																}}
// 															/>
// 														</div>
// 													) : (
// 														<div
// 															onClick={() => licenseImageBackInputRef.current.click()}
// 															style={{
// 																display: "flex",
// 																justifyContent: "center",
// 																marginTop: 30,
// 																cursor: "pointer",
// 															}}>
// 															<Avatar className={classes.avatar} variant="square" sx={{ boxShadow: 3 }}>
// 																<FileUploadIcon
// 																	sx={{
// 																		fontSize: 100,
// 																		marginBottom: 3,
// 																		color: "grey",
// 																	}}
// 																/>
// 																{t("upload_driving_license_back")}
// 															</Avatar>
// 														</div>
// 													)}
// 													<input
// 														onChange={(event) => licenseImageBackChange(event)}
// 														multiple={false}
// 														ref={licenseImageBackInputRef}
// 														type="file"
// 														hidden
// 													/>
// 												</>
// 											</>
// 										) : null}
// 									</>
// 								) : (
// 									<Grid container spacing={10}>
// 										<Grid
// 											item
// 											xs={12}
// 											sm={12}
// 											md={12}
// 											lg={data.usertype === "customer" ? 12 : 4}
// 											xl={data.usertype === "customer" ? 12 : 4}
// 											style={{
// 												display: "flex",
// 												justifyContent: "center",
// 												alignItems: "center",
// 												flexDirection: "column",
// 												gap: 15,
// 											}}>
// 											<Grid
// 												item
// 												style={{
// 													width: "100%",
// 												}}>
// 												<Card className={classes.card}>
// 													<Typography
// 														style={{
// 															textAlign: "center",
// 															fontSize: 16,
// 															fontWeight: "bold",
// 														}}>
// 														{t("verifyid_image")}
// 													</Typography>
// 												</Card>
// 											</Grid>
// 											<Grid
// 												item
// 												sx={{
// 													display: "flex",
// 													justifyContent: "center",
// 													alignItems: "center",
// 												}}>
// 												{data.verifyIdImage ? (
// 													<div onClick={() => setEditable(true)}>
// 														<Avatar
// 															alt="Id Image"
// 															src={data.verifyIdImage}
// 															sx={{
// 																width: 300,
// 																height: 250,
// 																borderRadius: "19px",
// 																cursor: "pointer",
// 															}}
// 															variant="square"
// 														/>
// 													</div>
// 												) : (
// 													<div onClick={() => setEditable(true)}>
// 														<Avatar className={classes.avatar} variant="square" sx={{ boxShadow: 3, cursor: "pointer" }}>
// 															{t("verifyid_image")}
// 														</Avatar>
// 													</div>
// 												)}
// 											</Grid>
// 										</Grid>
// 										{data?.usertype === "driver" ? (
// 											<>
// 												<Grid
// 													item
// 													xs={12}
// 													sm={12}
// 													md={12}
// 													lg={4}
// 													xl={4}
// 													style={{
// 														display: "flex",
// 														justifyContent: "center",
// 														alignItems: "center",
// 														flexDirection: "column",
// 														gap: 15,
// 													}}>
// 													<Grid item style={{ width: "100%" }}>
// 														<Card className={classes.card}>
// 															<Typography
// 																style={{
// 																	textAlign: "center",
// 																	fontSize: 16,
// 																	fontWeight: "bold",
// 																}}>
// 																{t("driving_license_font")}
// 															</Typography>
// 														</Card>
// 													</Grid>
// 													<Grid
// 														item
// 														sx={{
// 															display: "flex",
// 															justifyContent: "center",
// 															alignItems: "center",
// 														}}>
// 														{data.licenseImage ? (
// 															<div onClick={() => setEditable(true)}>
// 																<Avatar
// 																	alt="Id Image"
// 																	src={data.licenseImage}
// 																	sx={{
// 																		width: 300,
// 																		height: 250,
// 																		borderRadius: "19px",
// 																		cursor: "pointer",
// 																	}}
// 																	variant="square"
// 																/>
// 															</div>
// 														) : (
// 															<div onClick={() => setEditable(true)}>
// 																<Avatar className={classes.avatar} variant="square" sx={{ boxShadow: 3, cursor: "pointer" }}>
// 																	{t("driving_license_font")}
// 																</Avatar>
// 															</div>
// 														)}
// 													</Grid>
// 												</Grid>
// 												<Grid
// 													item
// 													xs={12}
// 													sm={12}
// 													md={12}
// 													lg={4}
// 													xl={4}
// 													style={{
// 														display: "flex",
// 														justifyContent: "center",
// 														alignItems: "center",
// 														flexDirection: "column",
// 														gap: 15,
// 													}}>
// 													<Grid item style={{ width: "100%" }}>
// 														<Card className={classes.card}>
// 															<Typography
// 																style={{
// 																	textAlign: "center",
// 																	fontSize: 16,
// 																	fontWeight: "bold",
// 																}}>
// 																{t("driving_license_back")}
// 															</Typography>
// 														</Card>
// 													</Grid>
// 													<Grid
// 														item
// 														sx={{
// 															display: "flex",
// 															justifyContent: "center",
// 															alignItems: "center",
// 														}}>
// 														{data.licenseImageBack ? (
// 															<div onClick={() => setEditable(true)}>
// 																<Avatar
// 																	alt="Id Image"
// 																	src={data.licenseImageBack}
// 																	sx={{
// 																		width: 300,
// 																		height: 250,
// 																		borderRadius: "19px",
// 																		cursor: "pointer",
// 																	}}
// 																	variant="square"
// 																/>
// 															</div>
// 														) : (
// 															<div onClick={() => setEditable(true)}>
// 																<Avatar className={classes.avatar} variant="square" sx={{ boxShadow: 3, cursor: "pointer" }}>
// 																	{t("driving_license_back")}
// 																</Avatar>
// 															</div>
// 														)}
// 													</Grid>
// 												</Grid>
// 											</>
// 										) : null}
// 									</Grid>
// 								)}
// 							</Grid>
// 						</Grid>
// 						<Grid item>
// 							{!editable ? (
// 								<Button
// 									className={classes.buttonStyle}
// 									style={{
// 										backgroundColor: MAIN_COLOR,
// 										width: "50%",
// 									}}
// 									variant="contained"
// 									onClick={() => setEditable(true)}
// 									sx={{
// 										cursor: "pointer",
// 										borderColor: colors.CARD_DETAIL,
// 									}}>
// 									<Typography
// 										style={{
// 											textAlign: "center",
// 											fontSize: 16,
// 											color: colors.WHITE,
// 											fontWeight: "bold",
// 										}}>
// 										{t("edit")}
// 									</Typography>
// 								</Button>
// 							) : (
// 								<div
// 									style={{
// 										display: "flex",
// 										justifyContent: "center",
// 										alignContent: "center",
// 										flexDirection: isRTL === "rtl" ? "row-reverse" : "row",
// 										gap: 10,
// 									}}>
// 									<Button
// 										className={classes.buttonStyle}
// 										style={{
// 											backgroundColor: colors.GREEN,
// 											width: "40%",
// 										}}
// 										variant="contained"
// 										onClick={handleSaveUser}>
// 										<Typography
// 											style={{
// 												color: "white",
// 												textAlign: "center",
// 												fontSize: 16,
// 												fontWeight: "bold",
// 											}}>
// 											{t("save")}
// 										</Typography>
// 									</Button>
// 									<Button
// 										className={classes.buttonStyle}
// 										style={{
// 											backgroundColor: colors.RED,
// 											width: "40%",
// 										}}
// 										variant="contained"
// 										onClick={handleCancel}>
// 										<Typography
// 											style={{
// 												textAlign: "center",
// 												fontSize: 16,
// 												fontWeight: "bold",
// 												color: colors.WHITE,
// 											}}>
// 											{t("cancel")}
// 										</Typography>
// 									</Button>
// 								</div>
// 							)}
// 						</Grid>
// 					</Grid>
// 				</Card>
// 				<AlertDialog open={commonAlert.open} onClose={handleCommonAlertClose}>
// 					{commonAlert.msg}
// 				</AlertDialog>
// 			</div>
// 		</>
// 	);
// }

// export default UserDocuments;

import React, { useState, useEffect, useRef } from "react";
import { Typography, Grid, Card, Button, Box, IconButton, Tooltip, CircularProgress, TextField } from "@mui/material";
import { useParams } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";
import FileUploadIcon from "@mui/icons-material/FileUpload";
import DownloadIcon from "@mui/icons-material/Download";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import DescriptionIcon from "@mui/icons-material/Description";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import AlertDialog from "../components/AlertDialog";
import { api } from "common";
import { makeStyles } from "@mui/styles";
import EditIcon from "@mui/icons-material/Edit";
import SaveIcon from "@mui/icons-material/Save";

// Define colors
const MAIN_COLOR = "#2196F3";
const SECONDORY_COLOR = "#f5f5f5";
const ERROR_COLOR = "#f44336";
const SUCCESS_COLOR = "#4caf50";

const useStyles = makeStyles(() => ({
	documentCard: {
		borderRadius: "16px",
		padding: "24px",
		height: "100%",
		display: "flex",
		flexDirection: "column",
		transition: "all 0.3s ease",
		"&:hover": {
			boxShadow: "0 8px 16px rgba(0,0,0,0.1)",
		},
	},
	documentTitle: {
		marginBottom: "16px",
		fontWeight: "600",
		textAlign: "center",
	},
	uploadArea: {
		border: `2px dashed ${MAIN_COLOR}`,
		borderRadius: "12px",
		padding: "24px",
		display: "flex",
		flexDirection: "column",
		alignItems: "center",
		justifyContent: "center",
		cursor: "pointer",
		height: "200px",
		backgroundColor: "rgba(33, 150, 243, 0.05)",
		transition: "all 0.2s ease",
		"&:hover": {
			backgroundColor: "rgba(33, 150, 243, 0.1)",
		},
	},
	previewContainer: {
		position: "relative",
		height: "200px",
		width: "100%",
		borderRadius: "12px",
		overflow: "hidden",
	},
	previewImage: {
		height: "100%",
		width: "100%",
		objectFit: "cover",
		borderRadius: "12px",
	},
	pdfPreview: {
		height: "100%",
		width: "100%",
		display: "flex",
		flexDirection: "column",
		alignItems: "center",
		justifyContent: "center",
		backgroundColor: "rgba(33, 150, 243, 0.05)",
		borderRadius: "12px",
	},
	controlButtons: {
		position: "absolute",
		bottom: "8px",
		right: "8px",
		display: "flex",
		gap: "8px",
		backgroundColor: "rgba(255, 255, 255, 0.8)",
		borderRadius: "8px",
		padding: "4px",
	},
	submitButton: {
		borderRadius: "28px",
		padding: "12px 32px",
		fontWeight: "bold",
		textTransform: "none",
		boxShadow: "0 4px 12px rgba(33, 150, 243, 0.2)",
		transition: "all 0.3s ease",
		"&:hover": {
			boxShadow: "0 6px 16px rgba(33, 150, 243, 0.3)",
			transform: "translateY(-2px)",
		},
	},
	backButton: {
		marginBottom: "24px",
		display: "flex",
		alignItems: "center",
		transition: "all 0.2s ease",
		"&:hover": {
			transform: "translateX(-4px)",
		},
	},
}));

function UserDocuments() {
	const { id } = useParams();
	const { t, i18n } = useTranslation();
	const isRTL = i18n.dir();
	const navigate = useNavigate();
	const { fetchUsersOnce, updateLicenseImage, editUser } = api;
	const staticusers = useSelector((state) => state.usersdata.staticusers);
	const [data, setData] = useState([]);
	const dispatch = useDispatch();

	// Refs for file inputs
	const IdInputRef = useRef();
	const licenseImageFrontInputRef = useRef();
	const licenseImageBackInputRef = useRef();

	// Document states
	const [idImage, setIdImage] = useState(null);
	const [licenseImageFront, setLicenseImageFront] = useState(null);
	const [licenseImageBack, setLicenseImageBack] = useState(null);

	// Expiration date states
	const [idExpDate, setIdExpDate] = useState("");
	const [licenseFrontExpDate, setLicenseFrontExpDate] = useState("");
	const [licenseBackExpDate, setLicenseBackExpDate] = useState("");
	const [updatingExpDate, setUpdatingExpDate] = useState({
		idImage: false,
		licenseFront: false,
		licenseBack: false,
	});

	// UI states
	const [commonAlert, setCommonAlert] = useState({ open: false, msg: "" });
	const [loading, setLoading] = useState(false);
	const [uploading, setUploading] = useState(false);
	const [successMessage, setSuccessMessage] = useState("");
	const [isIdImageType, setIsIdImageType] = useState(true);
	const [isLicenseImageFrontType, setIsLicenseImageFrontType] = useState(true);
	const [isLicenseImageBackType, setIsLicenseImageBackType] = useState(true);

	const classes = useStyles();

	useEffect(() => {
		dispatch(fetchUsersOnce());
	}, [dispatch, fetchUsersOnce]);

	useEffect(() => {
		if (staticusers) {
			const user = staticusers.filter((user) => user.id === id.toString())[0];
			if (!user) {
				navigate("/404");
			}
			setData(user);
			// Initialize expiration dates from user data
			if (user) {
				setIdExpDate(user.doc_exp_verifyIdImage || "");
				setLicenseFrontExpDate(user.doc_exp_licenseImage || "");
				setLicenseBackExpDate(user.doc_exp_licenseImageBack || "");
			}
		} else {
			setData([]);
		}
	}, [staticusers, id, navigate]);

	// Handle file changes
	const handleFileChange = (e, type) => {
		const file = e.target.files[0];

		if (!file) return;

		// Validate file type (allow only images and PDFs)
		const fileType = file.type;
		if (!fileType.includes("image") && fileType !== "application/pdf") {
			setCommonAlert({
				open: true,
				msg: t("only_image_pdf_allowed") || "Only images and PDF files are allowed.",
			});
			return;
		}

		// Validate file size (max 5MB)
		if (file.size > 5 * 1024 * 1024) {
			setCommonAlert({
				open: true,
				msg: t("file_too_large") || "File size should not exceed 5MB.",
			});
			return;
		}

		switch (type) {
			case "idImage":
				setIdImage(file);
				break;
			case "licenseImageFront":
				setLicenseImageFront(file);
				break;
			case "licenseImageBack":
				setLicenseImageBack(file);
				break;
			default:
				break;
		}
	};

	// Handle document upload
	const handleUploadDocuments = async () => {
		setUploading(true);

		try {
			// Check if at least one document is selected
			if (!idImage && !licenseImageFront && !licenseImageBack) {
				setCommonAlert({
					open: true,
					msg: t("select_at_least_one_document") || "Please select at least one document to upload.",
				});
				setUploading(false);
				return;
			}

			// Upload ID Image
			if (idImage) {
				await dispatch(updateLicenseImage(data.id, idImage, "verifyIdImage"));
			}

			// Upload License Front Image
			if (licenseImageFront) {
				await dispatch(updateLicenseImage(data.id, licenseImageFront, "licenseImage"));
			}

			// Upload License Back Image
			if (licenseImageBack) {
				await dispatch(updateLicenseImage(data.id, licenseImageBack, "licenseImageBack"));
			}

			// Refresh user data
			await dispatch(fetchUsersOnce());

			// Show success message
			setSuccessMessage(t("documents_uploaded_successfully") || "Documents uploaded successfully!");
			setTimeout(() => setSuccessMessage(""), 5000);

			// Reset file states
			setIdImage(null);
			setLicenseImageFront(null);
			setLicenseImageBack(null);
		} catch (error) {
			setCommonAlert({
				open: true,
				msg: t("upload_failed") || "Failed to upload documents. Please try again.",
			});
		} finally {
			setUploading(false);
		}
	};

	// Handle download document
	const handleDownloadDocument = (url, filename) => {
		if (!url) return;
		window.open(url, "_blank");
	};

	// Handle change document
	const handleChangeDocument = (documentType) => {
		switch (documentType) {
			case "idImage":
				setIdImage(null);
				IdInputRef.current.click();
				break;
			case "licenseImageFront":
				setLicenseImageFront(null);
				licenseImageFrontInputRef.current.click();
				break;
			case "licenseImageBack":
				setLicenseImageBack(null);
				licenseImageBackInputRef.current.click();
				break;
			default:
				break;
		}
	};

	// Check if a file is a PDF
	const isPdf = (file) => {
		if (!file) return false;
		return file.type === "application/pdf";
	};

	// Get preview URL for a file
	const getPreviewUrl = (file) => {
		if (!file) return null;
		return URL.createObjectURL(file);
	};

	// Handle expiration date update
	const handleUpdateExpirationDate = async (documentType) => {
		let expDate = "";
		let fieldName = "";

		switch (documentType) {
			case "idImage":
				expDate = idExpDate;
				fieldName = "doc_exp_verifyIdImage";
				setUpdatingExpDate((prev) => ({ ...prev, idImage: true }));
				break;
			case "licenseFront":
				expDate = licenseFrontExpDate;
				fieldName = "doc_exp_licenseImage";
				setUpdatingExpDate((prev) => ({ ...prev, licenseFront: true }));
				break;
			case "licenseBack":
				expDate = licenseBackExpDate;
				fieldName = "doc_exp_licenseImageBack";
				setUpdatingExpDate((prev) => ({ ...prev, licenseBack: true }));
				break;
			default:
				return;
		}

		if (!expDate) {
			setCommonAlert({
				open: true,
				msg: t("please_select_expiration_date") || "Please select an expiration date.",
			});
			setUpdatingExpDate((prev) => ({
				...prev,
				[documentType === "idImage" ? "idImage" : documentType === "licenseFront" ? "licenseFront" : "licenseBack"]: false,
			}));
			return;
		}

		try {
			const updateData = {
				...data,
				[fieldName]: expDate,
				updateAt: new Date().getTime(),
			};
			await dispatch(editUser(data.id, updateData));
			await dispatch(fetchUsersOnce());
			setSuccessMessage(t("expiration_date_updated_successfully") || "Expiration date updated successfully!");
			setTimeout(() => setSuccessMessage(""), 5000);
		} catch (error) {
			setCommonAlert({
				open: true,
				msg: t("failed_to_update_expiration_date") || "Failed to update expiration date. Please try again.",
			});
		} finally {
			setUpdatingExpDate((prev) => ({
				...prev,
				[documentType === "idImage" ? "idImage" : documentType === "licenseFront" ? "licenseFront" : "licenseBack"]: false,
			}));
		}
	};

	// Dialog close handler
	const handleAlertClose = () => {
		setCommonAlert({ open: false, msg: "" });
	};

	// Loading state
	if (loading) {
		return (
			<Box display="flex" justifyContent="center" alignItems="center" minHeight="80vh">
				<CircularProgress size={60} thickness={4} />
			</Box>
		);
	}

	return (
		<Box sx={{ p: 3, maxWidth: "1200px", mx: "auto" }}>
			<Button className={classes.backButton} startIcon={<ArrowBackIcon />} onClick={() => navigate("/users")} color="primary">
				{t("go_back") || "Go Back"}
			</Button>

			<Typography variant="h4" gutterBottom fontWeight="bold" sx={{ mb: 4 }}>
				{t("documents_title") || "User Documents"}
			</Typography>

			{successMessage && (
				<Box
					sx={{
						p: 2,
						mb: 3,
						bgcolor: "rgba(76, 175, 80, 0.1)",
						borderRadius: 2,
						display: "flex",
						alignItems: "center",
					}}>
					<Typography color="success.main">{successMessage}</Typography>
				</Box>
			)}

			<Grid container spacing={3}>
				{/* ID Verification Image */}
				<Grid item xs={12} md={data?.usertype === "customer" ? 12 : 4}>
					<Card className={classes.documentCard}>
						<Typography variant="h6" className={classes.documentTitle}>
							{t("verifyid_image") || "ID Verification"}
						</Typography>

						{data?.verifyIdImage ? (
							<Box className={classes.previewContainer}>
								{isIdImageType ? (
									<img src={data?.verifyIdImage} alt="ID Verification" className={classes.previewImage} onError={() => setIsIdImageType(false)} />
								) : (
									<Box className={classes.pdfPreview}>
										<DescriptionIcon sx={{ fontSize: 64, color: MAIN_COLOR }} />
										<Typography variant="body2" sx={{ mt: 1 }}>
											PDF Document
										</Typography>
									</Box>
								)}
								<Box className={classes.controlButtons}>
									<Tooltip title={t("download") || "Download"}>
										<IconButton
											size="small"
											onClick={() => handleDownloadDocument(data?.verifyIdImage, "ID_Verification")}
											sx={{ backgroundColor: MAIN_COLOR, color: "#fff" }}>
											<DownloadIcon />
										</IconButton>
									</Tooltip>
									<Tooltip title={t("edit") || "Edit"}>
										<IconButton size="small" onClick={() => handleChangeDocument("idImage")} sx={{ backgroundColor: SECONDORY_COLOR, color: "#000" }}>
											<EditIcon />
										</IconButton>
									</Tooltip>
								</Box>
							</Box>
						) : idImage ? (
							<Box className={classes.previewContainer}>
								{isPdf(idImage) ? (
									<Box className={classes.pdfPreview}>
										<DescriptionIcon sx={{ fontSize: 64, color: MAIN_COLOR }} />
										<Typography variant="body2" sx={{ mt: 1 }}>
											{idImage.name}
										</Typography>
									</Box>
								) : (
									<img src={getPreviewUrl(idImage)} alt="ID Verification" className={classes.previewImage} />
								)}
								<Box className={classes.controlButtons}>
									<Tooltip title={t("remove") || "Remove"}>
										<IconButton size="small" onClick={() => setIdImage(null)} sx={{ backgroundColor: ERROR_COLOR, color: "#fff" }}>
											<DeleteOutlineIcon />
										</IconButton>
									</Tooltip>
								</Box>
							</Box>
						) : (
							<Box className={classes.uploadArea} onClick={() => IdInputRef.current.click()}>
								<FileUploadIcon sx={{ fontSize: 48, color: MAIN_COLOR, mb: 2 }} />
								<Typography variant="body1" align="center">
									{t("upload_id_details") || "Upload ID Verification"}
								</Typography>
								<Typography variant="caption" align="center" sx={{ mt: 1 }}>
									{t("file_formats") || "JPG, PNG or PDF (max 5MB)"}
								</Typography>
							</Box>
						)}

						<input type="file" hidden ref={IdInputRef} onChange={(e) => handleFileChange(e, "idImage")} accept="image/*,application/pdf" />

						{/* Expiration Date Section */}
						<Box sx={{ mt: 3, display: "flex", flexDirection: "column", gap: 1 }}>
							<Typography variant="body2" sx={{ fontWeight: 500, mb: 1 }}>
								{t("expiration_date") || "Expiration Date"}
							</Typography>
							<Box sx={{ display: "flex", gap: 1, alignItems: "center" }}>
								<TextField
									type="date"
									size="small"
									fullWidth
									value={idExpDate}
									onChange={(e) => setIdExpDate(e.target.value)}
									InputLabelProps={{
										shrink: true,
									}}
									sx={{ flex: 1 }}
								/>
								<Tooltip title={t("update_expiration_date") || "Update Expiration Date"}>
									<IconButton
										size="small"
										onClick={() => handleUpdateExpirationDate("idImage")}
										disabled={updatingExpDate.idImage}
										sx={{ backgroundColor: MAIN_COLOR, color: "#fff", "&:hover": { backgroundColor: "#1976d2" }, padding: 1 }}>
										{updatingExpDate.idImage ? <CircularProgress size={20} color="inherit" /> : <SaveIcon sx={{ fontSize: 20 }} />}
									</IconButton>
								</Tooltip>
							</Box>
						</Box>
					</Card>
				</Grid>

				{/* Driver License Front - Only show for drivers */}
				{data?.usertype === "driver" && (
					<Grid item xs={12} md={4}>
						<Card className={classes.documentCard}>
							<Typography variant="h6" className={classes.documentTitle}>
								{t("driving_license_font") || "Driver License Front"}
							</Typography>

							{data?.licenseImage ? (
								<Box className={classes.previewContainer}>
									{isLicenseImageFrontType ? (
										<img
											src={data?.licenseImage}
											alt="License Front"
											className={classes.previewImage}
											onError={() => setIsLicenseImageFrontType(false)}
										/>
									) : (
										<Box className={classes.pdfPreview}>
											<DescriptionIcon sx={{ fontSize: 64, color: MAIN_COLOR }} />
											<Typography variant="body2" sx={{ mt: 1 }}>
												PDF Document
											</Typography>
										</Box>
									)}
									<Box className={classes.controlButtons}>
										<Tooltip title={t("download") || "Download"}>
											<IconButton
												size="small"
												onClick={() => handleDownloadDocument(data?.licenseImage, "License_Front")}
												sx={{ backgroundColor: MAIN_COLOR, color: "#fff" }}>
												<DownloadIcon />
											</IconButton>
										</Tooltip>
										<Tooltip title={t("edit") || "Edit"}>
											<IconButton
												size="small"
												onClick={() => handleChangeDocument("licenseImageFront")}
												sx={{ backgroundColor: SECONDORY_COLOR, color: "#000" }}>
												<EditIcon />
											</IconButton>
										</Tooltip>
									</Box>
								</Box>
							) : licenseImageFront ? (
								<Box className={classes.previewContainer}>
									{isPdf(licenseImageFront) ? (
										<Box className={classes.pdfPreview}>
											<DescriptionIcon sx={{ fontSize: 64, color: MAIN_COLOR }} />
											<Typography variant="body2" sx={{ mt: 1 }}>
												{licenseImageFront.name}
											</Typography>
										</Box>
									) : (
										<img src={getPreviewUrl(licenseImageFront)} alt="License Front" className={classes.previewImage} />
									)}
									<Box className={classes.controlButtons}>
										<Tooltip title={t("remove") || "Remove"}>
											<IconButton size="small" onClick={() => setLicenseImageFront(null)} sx={{ backgroundColor: ERROR_COLOR, color: "#fff" }}>
												<DeleteOutlineIcon />
											</IconButton>
										</Tooltip>
									</Box>
								</Box>
							) : (
								<Box className={classes.uploadArea} onClick={() => licenseImageFrontInputRef.current.click()}>
									<FileUploadIcon sx={{ fontSize: 48, color: MAIN_COLOR, mb: 2 }} />
									<Typography variant="body1" align="center">
										{t("upload_driving_license_front") || "Upload License Front"}
									</Typography>
									<Typography variant="caption" align="center" sx={{ mt: 1 }}>
										{t("file_formats") || "JPG, PNG or PDF (max 5MB)"}
									</Typography>
								</Box>
							)}

							<input
								type="file"
								hidden
								ref={licenseImageFrontInputRef}
								onChange={(e) => handleFileChange(e, "licenseImageFront")}
								accept="image/*,application/pdf"
							/>

							{/* Expiration Date Section */}
							<Box sx={{ mt: 3, display: "flex", flexDirection: "column", gap: 1 }}>
								<Typography variant="body2" sx={{ fontWeight: 500, mb: 1 }}>
									{t("expiration_date") || "Expiration Date"}
								</Typography>
								<Box sx={{ display: "flex", gap: 1, alignItems: "center" }}>
									<TextField
										type="date"
										size="small"
										fullWidth
										value={licenseFrontExpDate}
										onChange={(e) => setLicenseFrontExpDate(e.target.value)}
										InputLabelProps={{
											shrink: true,
										}}
										sx={{ flex: 1 }}
									/>
									<Tooltip title={t("update_expiration_date") || "Update Expiration Date"}>
										<IconButton
											size="small"
											onClick={() => handleUpdateExpirationDate("licenseFront")}
											disabled={updatingExpDate.licenseFront}
											sx={{ backgroundColor: MAIN_COLOR, color: "#fff", "&:hover": { backgroundColor: "#1976d2" }, padding: 1 }}>
											{updatingExpDate.licenseFront ? <CircularProgress size={20} color="inherit" /> : <SaveIcon sx={{ fontSize: 20 }} />}
										</IconButton>
									</Tooltip>
								</Box>
							</Box>
						</Card>
					</Grid>
				)}

				{/* Driver License Back - Only show for drivers */}
				{data?.usertype === "driver" && (
					<Grid item xs={12} md={4}>
						<Card className={classes.documentCard}>
							<Typography variant="h6" className={classes.documentTitle}>
								{t("driving_license_back") || "Driver License Back"}
							</Typography>

							{data?.licenseImageBack ? (
								<Box className={classes.previewContainer}>
									{isLicenseImageBackType ? (
										<img
											src={data?.licenseImageBack}
											alt="License Back"
											className={classes.previewImage}
											onError={() => setIsLicenseImageBackType(false)}
										/>
									) : (
										<Box className={classes.pdfPreview}>
											<DescriptionIcon sx={{ fontSize: 64, color: MAIN_COLOR }} />
											<Typography variant="body2" sx={{ mt: 1 }}>
												PDF Document
											</Typography>
										</Box>
									)}
									<Box className={classes.controlButtons}>
										<Tooltip title={t("download") || "Download"}>
											<IconButton
												size="small"
												onClick={() => handleDownloadDocument(data?.licenseImageBack, "License_Back")}
												sx={{ backgroundColor: MAIN_COLOR, color: "#fff" }}>
												<DownloadIcon />
											</IconButton>
										</Tooltip>
										<Tooltip title={t("edit") || "Edit"}>
											<IconButton
												size="small"
												onClick={() => handleChangeDocument("licenseImageBack")}
												sx={{ backgroundColor: SECONDORY_COLOR, color: "#000" }}>
												<EditIcon />
											</IconButton>
										</Tooltip>
									</Box>
								</Box>
							) : licenseImageBack ? (
								<Box className={classes.previewContainer}>
									{isPdf(licenseImageBack) ? (
										<Box className={classes.pdfPreview}>
											<DescriptionIcon sx={{ fontSize: 64, color: MAIN_COLOR }} />
											<Typography variant="body2" sx={{ mt: 1 }}>
												{licenseImageBack.name}
											</Typography>
										</Box>
									) : (
										<img src={getPreviewUrl(licenseImageBack)} alt="License Back" className={classes.previewImage} />
									)}
									<Box className={classes.controlButtons}>
										<Tooltip title={t("remove") || "Remove"}>
											<IconButton size="small" onClick={() => setLicenseImageBack(null)} sx={{ backgroundColor: ERROR_COLOR, color: "#fff" }}>
												<DeleteOutlineIcon />
											</IconButton>
										</Tooltip>
									</Box>
								</Box>
							) : (
								<Box className={classes.uploadArea} onClick={() => licenseImageBackInputRef.current.click()}>
									<FileUploadIcon sx={{ fontSize: 48, color: MAIN_COLOR, mb: 2 }} />
									<Typography variant="body1" align="center">
										{t("upload_driving_license_back") || "Upload License Back"}
									</Typography>
									<Typography variant="caption" align="center" sx={{ mt: 1 }}>
										{t("file_formats") || "JPG, PNG or PDF (max 5MB)"}
									</Typography>
								</Box>
							)}

							<input
								type="file"
								hidden
								ref={licenseImageBackInputRef}
								onChange={(e) => handleFileChange(e, "licenseImageBack")}
								accept="image/*,application/pdf"
							/>

							{/* Expiration Date Section */}
							<Box sx={{ mt: 3, display: "flex", flexDirection: "column", gap: 1 }}>
								<Typography variant="body2" sx={{ fontWeight: 500, mb: 1 }}>
									{t("expiration_date") || "Expiration Date"}
								</Typography>
								<Box sx={{ display: "flex", gap: 1, alignItems: "center" }}>
									<TextField
										type="date"
										size="small"
										fullWidth
										value={licenseBackExpDate}
										onChange={(e) => setLicenseBackExpDate(e.target.value)}
										InputLabelProps={{
											shrink: true,
										}}
										sx={{ flex: 1 }}
									/>
									<Tooltip title={t("update_expiration_date") || "Update Expiration Date"}>
										<IconButton
											size="small"
											onClick={() => handleUpdateExpirationDate("licenseBack")}
											disabled={updatingExpDate.licenseBack}
											sx={{ backgroundColor: MAIN_COLOR, color: "#fff", "&:hover": { backgroundColor: "#1976d2" }, padding: 1 }}>
											{updatingExpDate.licenseBack ? <CircularProgress size={20} color="inherit" /> : <SaveIcon sx={{ fontSize: 20 }} />}
										</IconButton>
									</Tooltip>
								</Box>
							</Box>
						</Card>
					</Grid>
				)}
			</Grid>

			{/* Upload Button */}
			{(idImage || licenseImageFront || licenseImageBack) && (
				<Box sx={{ display: "flex", justifyContent: "center", mt: 4 }}>
					<Button
						variant="contained"
						color="primary"
						disabled={uploading}
						onClick={handleUploadDocuments}
						className={classes.submitButton}
						startIcon={uploading ? <CircularProgress size={20} color="inherit" /> : null}>
						{uploading ? t("uploading") || "Uploading..." : t("upload_documents") || "Upload Documents"}
					</Button>
				</Box>
			)}

			{/* Alert Dialog */}
			<AlertDialog open={commonAlert.open} onClose={handleAlertClose}>
				{commonAlert.msg}
			</AlertDialog>
		</Box>
	);
}

export default UserDocuments;
